import { createFileRoute, useNavigate } from "@tanstack/react-router"

import { OnboardingSetupForm } from "@/features/onboarding/components/onboarding-setup-form"
import { onboardingQueries } from "@/queries/onboarding"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/onboarding/new/"
)({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(onboardingQueries.setup(params.firmId)),
  component: SetUpOnboardingPage,
})

function SetUpOnboardingPage() {
  const { firmId } = Route.useParams()
  const navigate = useNavigate()

  return (
    <OnboardingSetupForm
      firmId={firmId}
      onStarted={() =>
        void navigate({
          from: "/$organisation",
          to: "/$organisation/firms/$firmId/onboarding",
          params: { firmId },
        })
      }
      onCancel={() =>
        void navigate({
          from: "/$organisation",
          to: "/$organisation/firms/$firmId",
          params: { firmId },
        })
      }
    />
  )
}
